"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYCLevel = _interopRequireDefault(require("../KYC/KYCLevel"));
var _kycLevelsVerificationPropsHelper = require("../KYC/kycLevelsVerificationPropsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var KYC_JumioLevelsComponent = function KYC_JumioLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
    level1 = props.level1,
    level2 = props.level2,
    levelIncreaseStatus = props.levelIncreaseStatus,
    openKYCSidePane = props.openKYCSidePane,
    verificationLevel = props.verificationLevel;
  var level1Props = (0, _kycLevelsVerificationPropsHelper.getJumioLevel1VerificationProps)(verificationLevel);
  var level2Props = (0, _kycLevelsVerificationPropsHelper.getJumioLevel2VerificationProps)(verificationLevel, levelIncreaseStatus);
  return [level1 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level1.level,
    verified: true,
    config: level1
  }, level1Props, {
    highlightStyle: highlightStyle
  })), level2 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level2.level,
    config: level2
  }, level2Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  }))];
};
var _default = exports["default"] = KYC_JumioLevelsComponent;